/**
 * 事業ごとの色。
 *
 * 月次経理の一覧は 174 行あり、全部が同じ色だとどの事業の作業かを追えない。
 * 「共通」が 7 割を占めるのでこれは最も控えめな色に置き、事業固有の作業が
 * 浮かび上がるようにする。彩度は抑え、赤×緑の組み合わせは使わない。
 * @graph-connects none
 */
const BUSINESS_COLOR: Record<string, { color: string; background: string }> = {
  共通: { color: 'var(--color-biz-common)', background: 'var(--color-biz-common-bg)' },
  aC: { color: 'var(--color-biz-ac)', background: 'var(--color-biz-ac-bg)' },
  mall: { color: 'var(--color-biz-mall)', background: 'var(--color-biz-mall-bg)' },
  サロン: { color: 'var(--color-biz-salon)', background: 'var(--color-biz-salon-bg)' },
  スポットレンタル: { color: 'var(--color-biz-spot)', background: 'var(--color-biz-spot-bg)' },
  アウター: { color: 'var(--color-biz-outer)', background: 'var(--color-biz-outer-bg)' },
  小物販売: { color: 'var(--color-biz-goods)', background: 'var(--color-biz-goods-bg)' },
  Port: { color: 'var(--color-biz-port)', background: 'var(--color-biz-port-bg)' },
  ACE: { color: 'var(--color-biz-ace)', background: 'var(--color-biz-ace-bg)' },
};

/**
 * @graph-stack ado-task
 * @graph-domain Finance
 * @graph-business 事業の色を返す。知らない事業はニュートラルに倒す
 * @graph-connects none
 */
export function businessColor(business: string): { color: string; background: string } {
  return (
    BUSINESS_COLOR[business] ?? {
      color: 'var(--color-text-muted)',
      background: 'var(--color-bg-subtle)',
    }
  );
}

/**
 * BusinessLabel の props。
 */
export interface BusinessLabelProps {
  /** 表示する事業 */
  business: string;
}

/**
 * @graph-stack ado-task
 * @graph-domain Finance
 * @graph-business 事業をチップで示す。一覧を流し読みしたときに事業ごとの塊が見えるようにする
 * @graph-connects businessColor [calls] 事業の色を引く
 */
export function BusinessLabel({ business }: BusinessLabelProps) {
  return (
    <span
      className="inline-block rounded px-1.5 py-0.5 text-xs whitespace-nowrap"
      style={businessColor(business)}
    >
      {business}
    </span>
  );
}
